export default {
    name: "TeamTicketsWidget",
    description: "Displays tickets that are not closed.",

    type: "DataWidget",
    roles: ["manager"],
    widget: {
        title: "Team's Open Tickets",
        dataProvider: {
            main: {
                rpc: "ManagerDashboardRpc.getTeamOpenTickets",
                transform: (response) => response?.data || []
            }
        },
        // --- FIX: Use enrichData to resolve the assigneeId to a username ---
        async enrichData(data, appClient) {
            if (data.main && data.main.length > 0) {
                // Create an array of promises for all the user lookups
                const enrichmentPromises = data.main.map(async (ticket) => {
                    if (ticket.assigneeId) {
                        const user = await appClient.rds.get('users', ticket.assigneeId);
                        // Replace the ID with the username for the template
                        ticket.assigneeName = user ? user.username : 'Unassigned';
                    } else {
                        ticket.assigneeName = 'Unassigned';
                    }
                    return ticket;
                });
                // Wait for all lookups to complete
                data.main = await Promise.all(enrichmentPromises);
            }
            return data;
        },
        itemAction: {
            type: 'navigate',
            route: '/user/tickets?ticketId={{_id}}'
        },
        itemTemplate: (item) => {
            const statusStyles = {
                'new': { color: 'danger', text: 'New' },
                'pending': { color: 'warning', text: 'Pending' },
                'open': { color: 'info', text: 'Open' }
            };
            const status = statusStyles[item.status] || { color: 'secondary', text: item.status };

            return `
                <style>
                    .ticket-card-team { padding: 0.75rem; border-left: 4px solid var(--bs-${status.color}); background-color: var(--bs-tertiary-bg); border-radius: var(--bs-border-radius); margin-bottom: 0.5rem; }
                </style>
                <div class="ticket-card-team">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold"><span class="text-muted">#${item.ticketNumber}</span> - ${item.subject}</div>
                            <small class="text-muted"><i class="bi bi-person-fill me-1"></i>${item.assigneeName}</small>
                        </div>
                        <div class="text-nowrap ms-3">
                             <span class="badge bg-${status.color}">${status.text}</span>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "No open tickets for the team."
    }
};